import type { Environment } from './environment.model';

/** Rebuild dev API (`rem-backend`) — see `src/app/features/auth/FRONTEND-API-CHANGES.md`. */
export const environment: Environment = {
  production: false,
  name: 'development',
  apiUrl: 'https://remmi-rebuild-dev-api.remmi.com.au/api',
  apiPrefix: 'v1',
  salePresentationUrl: 'https://dev-sales-presentation.remmi.com.au',
  wsEndpoint: 'wss://devws.remmi.com.au/',
  assetsS3Url: 'https://remmi-xm.s3-ap-southeast-2.amazonaws.com',
  runtimeConfigUrl: '/assets/runtime-config.json',
  logging: {
    debugEnabled: true,
  },
  auth: {
    accessTokenStorageKey: 'remmi_access_token',
    refreshTokenStorageKey: 'remmi_refresh_token',
    refreshTokenTransport: 'body',
    jwtRolesClaim: 'role',
    endpoints: {
      login: 'auth/login',
      refresh: 'auth/refresh',
      logout: 'auth/logout',
    },
    publicUrlPathPrefixes: ['/assets/', '/i18n/'],
  },
};
